import html2pdf from 'html2pdf.js';

/**
 * Returns CSS styles for PDF printing
 * @returns {string} CSS styles as a string
 */
export const getPDFStyles = () => {
  return `
    /* PDF Print Styles */
    /* Reset for printing */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html, body {
            width: 100%;
            font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            line-height: 1.4;
            color: #1d1d1f;
            background: white;
          }

          /* Main container */
          .print-container {
            width: 100%;
            max-width: 7.5in;
            padding: 0.5in;
            margin: 0 auto;
          }

          /* Conversation header */
          .conversation-header {
            margin-bottom: 2.5rem;
          }

          .conversation-header h1 {
            font-size: 24pt;
            font-weight: 500;
            color: #1d1d1f;
            margin-bottom: 0.5rem;
            letter-spacing: -0.022em;
          }

          .conversation-header p {
            font-size: 11pt;
            color: #86868b;
            letter-spacing: -0.01em;
          }

          /* Message styling */
          .message {
            margin-bottom: 1rem;
            padding: 0;
            page-break-inside: avoid;
          }

          .message-role {
            font-weight: bold;
            font-size: 10pt;
            letter-spacing: -0.01em;
            margin-bottom: 0;
            color: #0070c9;
          }

          .message.user .message-role {
            text-align: left;
            color: #c94600;
          }

          .message-content {
            line-height: 1.5;
            letter-spacing: -0.01em;
            font-size: 11pt;
            padding: 0.75rem 0;
            overflow-wrap: break-word;
            word-break: break-word;
            border: none;
            padding-top: 0;
          }

          .message.user .message-content {
            text-align: left;
            background-color: transparent;
            border: none;
            color: #1d1d1f;
          }

          .message.assistant .message-content {
            background-color: transparent;
            border: none;
            color: #1d1d1f;
          }

          /* List styling */
          .message-content ol {
            white-space: initial;
            padding-left: 20px;
          }

          .message-content ol li {
            margin-bottom: 24px;
          }

          .message-content ol li:last-child {
            margin-bottom: 0;
          }

          .message-content ul {
            padding-left: 20px;
            list-style-type: disc;
          }

          /* Footer styling */
          .conversation-footer {
            margin-top: 3rem;
            padding-top: 1rem;
            font-size: 9pt;
            color: #86868b;
            text-align: center;
            border-top: 1px solid #e2e2e7;
            letter-spacing: -0.01em;
          }

          /* Print settings */
          @page {
            margin: 0.5in;
            size: auto;
          }

          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
  `;
};

/**
 * Generate print content as a string with Apple document styling
 * @param {Object} params - Parameters for print content
 * @param {string} params.conversationHTML - HTML content to print
 * @param {string} params.documentTitle - Title of the document
 * @returns {string} HTML string ready for print window
 */
export const generatePrintContent = ({ conversationHTML, documentTitle }) => {
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${documentTitle || "Konversation"}</title>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <style>
          /* Reset for printing */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html, body {
            width: 100%;
            font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            line-height: 1.4;
            color: #1d1d1f;
            background: white;
          }

          /* Main container */
          .print-container {
            width: 100%;
            max-width: 7.5in;
            padding: 0.5in;
            margin: 0 auto;
          }

          /* Conversation header */
          .conversation-header {
            margin-bottom: 2.5rem;
          }

          .conversation-header h1 {
            font-size: 24pt;
            font-weight: 500;
            color: #1d1d1f;
            margin-bottom: 0.5rem;
            letter-spacing: -0.022em;
          }

          .conversation-header p {
            font-size: 11pt;
            color: #86868b;
            letter-spacing: -0.01em;
          }

          /* Message styling */
          .message {
            margin-bottom: 1rem;
            padding: 0;
            page-break-inside: avoid;
          }

          .message-role {
            font-weight: bold;
            font-size: 10pt;
            letter-spacing: -0.01em;
            margin-bottom: 0;
            color: #0070c9;
          }

          .message.user .message-role {
            text-align: left;
            color: #c94600;
          }

          .message-content {
            line-height: 1.5;
            letter-spacing: -0.01em;
            font-size: 11pt;
            padding: 0.75rem 0;
            overflow-wrap: break-word;
            word-break: break-word;
            border: none;
            padding-top: 0;
          }

          .message.user .message-content {
            text-align: left;
            background-color: transparent;
            border: none;
            color: #1d1d1f;
          }

          .message.assistant .message-content {
            background-color: transparent;
            border: none;
            color: #1d1d1f;
          }

          /* List styling */
          .message-content ol {
            white-space: initial;
            padding-left: 20px;
          }

          .message-content ol li {
            margin-bottom: 24px;
          }

          .message-content ol li:last-child {
            margin-bottom: 0;
          }

          .message-content ul {
            padding-left: 20px;
            list-style-type: disc;
          }

          /* Footer styling */
          .conversation-footer {
            margin-top: 3rem;
            padding-top: 1rem;
            font-size: 9pt;
            color: #86868b;
            text-align: center;
            border-top: 1px solid #e2e2e7;
            letter-spacing: -0.01em;
          }

          /* Print settings */
          @page {
            margin: 0.5in;
            size: auto;
          }

          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          ${conversationHTML}
        </div>
        <script>
          // Auto-print when content is loaded
          window.onload = function() {
            setTimeout(function() {
              window.print();
              // Optional: close window after printing
              // window.close();
            }, 500);
          }
        </script>
      </body>
    </html>
  `;
};

/**
 * Print the conversation in a new window
 * @param {Object} content - The printable content
 * @returns {void}
 */
export const printConversation = (content) => {
  if (!content) {
    console.error('No content provided for printing');
    return;
  }

  // Create a new window for printing
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert('Please allow pop-ups to print the conversation');
    return;
  }

  // Format date for display
  const formattedDate = content.created_at
    ? new Date(content.created_at).toLocaleDateString('de-CH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : '';

  // Generate HTML content
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${content.conversationName || 'Conversation'}</title>
      <meta charset="utf-8">
      <style>
        ${getPDFStyles()}
      </style>
    </head>
    <body>
      <div class="conversation-print">
        <div class="conversation-header">
          <h1>${content.conversationName || 'Konversation'}</h1>
          <p>${formattedDate}</p>
        </div>

        <div class="conversation-messages">
          ${content.messages.map(msg => `
            <div class="message ${msg.role}">
              <div class="message-role">
                ${msg.role === 'user' ? 'Sie' : 'Bernie\'s AI'}
              </div>
              <div class="message-content">
                ${msg.content.replace(/\n/g, '<br/>')}
              </div>
            </div>
          `).join('')}
        </div>

        <div class="conversation-footer">
          Bernie's AI by Quantonomics
        </div>
      </div>
    </body>
    </html>
  `;

  // Write to the window and print it
  printWindow.document.write(htmlContent);
  printWindow.document.close();

  // Wait for resources to load then print
  printWindow.onload = () => {
    printWindow.print();
    // printWindow.close(); // Uncomment to auto-close after print
  };
};

/**
 * Format a string to be used as a filename (remove umlauts, spaces, and special characters)
 * @param {string} str - The string to format
 * @returns {string} The formatted string
 */
const formatFilename = (str) => {
  if (!str) return '';

  // Replace umlauts
  let formatted = str
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/Ä/g, 'Ae')
    .replace(/Ö/g, 'Oe')
    .replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss');

  // Replace spaces and special characters
  formatted = formatted
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '');

  return formatted;
};

/**
 * Generate a PDF of the conversation
 * @param {Object} content - The conversation content
 * @returns {void}
 */
export const downloadConversationPdf = (content) => {
  if (!content) {
    console.error('No content provided for PDF download');
    return;
  }

  // Format date for display
  const formattedDate = content.created_at
    ? new Date(content.created_at).toLocaleDateString('de-CH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : '';

  // Create HTML content for PDF
  const htmlContent = `
    <div class="conversation-print">
      <style>${getPDFStyles()}</style>
      <div class="conversation-header">
        <h1>${content.conversationName || 'Konversation'}</h1>
        <p>${formattedDate}</p>
      </div>

      <div class="conversation-messages">
        ${content.messages.map(msg => `
          <div class="message ${msg.role}">
            <div class="message-role">
              ${msg.role === 'user' ? 'Sie' : 'Bernie\'s AI'}
            </div>
            <div class="message-content">
              ${msg.content.replace(/\n/g, '<br/>')}
            </div>
          </div>
        `).join('')}
      </div>

      <div class="conversation-footer">
        Bernie's AI by Quantonomics
      </div>
    </div>
  `;

  // Create an element to render the PDF from
  const element = document.createElement('div');
  element.innerHTML = htmlContent;
  document.body.appendChild(element);

  // Generate PDF options
  const opt = {
    margin: [10, 10],
    filename: `${formatFilename(content.conversationName) || 'Konversation'}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  // Generate the PDF
  html2pdf().from(element).set(opt).save().then(() => {
    // Clean up
    document.body.removeChild(element);
  });
};
